(function () {
  'use strict';

  const DATA = window.PAN_PAGE_DATA || {};
  const ALU = DATA.alu || null;
  const CI  = DATA.castIron || null;
  var _ps = DATA.strings || {};
  var PS = {
    errorCheckout: _ps.errorCheckout || 'Something went wrong. Please try again.'
  };

  let selectedPan = 'alu'; // default

  /* ── Helpers ── */
  function fmt(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function $(id) { return document.getElementById(id); }

  /* ── Select a pan ── */
  function selectPan(which) {
    selectedPan = which;

    const cardAlu = $('pan-card-alu');
    const cardCi  = $('pan-card-ci');
    if (cardAlu) {
      cardAlu.classList.toggle('pan-card--selected', which === 'alu');
      cardAlu.setAttribute('aria-pressed', which === 'alu' ? 'true' : 'false');
    }
    if (cardCi) {
      cardCi.classList.toggle('pan-card--selected', which === 'ci');
      cardCi.setAttribute('aria-pressed', which === 'ci' ? 'true' : 'false');
    }

    // Update hint text
    const hint = $('pan-cta-hint');
    if (hint) {
      const pan = which === 'ci' ? CI : ALU;
      if (pan) hint.textContent = pan.title + ' — ' + fmt(pan.price);
    }
  }

  /* ── Checkout ── */
  async function handleCheckout() {
    const pan = selectedPan === 'ci' ? CI : ALU;
    if (!pan) return;

    const overlay = $('pan-loading');
    if (overlay) overlay.style.display = 'flex';

    try {
      // Clear existing cart
      await fetch('/cart/clear.js', { method: 'POST' });

      // Add selected pan
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: pan.variantId, quantity: 1 }] })
      });

      // Truth and Reconciliation Day gift line (assets/trc-gift.js). Bounded, never throws.
      if (window.AtomeTRC) await window.AtomeTRC.ensure();

      // Go straight to checkout
      window.location.href = '/checkout';
    } catch (e) {
      if (overlay) overlay.style.display = 'none';
      alert(PS.errorCheckout);
    }
  }

  /* ── Init ── */
  function init() {
    // Pan card clicks
    ['alu', 'ci'].forEach(which => {
      const card = $('pan-card-' + which);
      if (!card) return;
      card.addEventListener('click', () => selectPan(which));
      card.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectPan(which); }
      });
    });

    // Main checkout buttons
    ['pan-checkout-btn', 'pan-final-checkout-btn'].forEach(id => {
      const btn = $(id);
      if (btn) btn.addEventListener('click', handleCheckout);
    });

    // Deep dive CTA — selects cast iron first, then checks out
    const deepDiveCta = $('pan-deepdive-cta');
    if (deepDiveCta) {
      deepDiveCta.addEventListener('click', () => {
        selectPan('ci');
        handleCheckout();
      });
    }

    // Smooth scroll for hero CTA
    document.querySelectorAll('a[href="#pan-selector"]').forEach(a => {
      a.addEventListener('click', e => {
        e.preventDefault();
        const target = $('pan-selector');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    // Set initial hint text
    selectPan('alu');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
